import { AnyResourceDefinition, ErrorOf } from '../../../resources/types';
import { getResourceErrorMeta } from '../../../client/errorMeta';

export class RpcError<TRpcError = unknown> extends Error {
  readonly rpcError: TRpcError;

  constructor(rpcError: TRpcError, callSiteStack?: string) {
    super('CHIRP RPC failed');
    this.name = 'RpcError';
    this.rpcError = rpcError;

    if (callSiteStack) {
      this.stack = callSiteStack;
    }
  }
}

type ExtractRpcErrorPayload<TError> = TError extends RpcError<infer T>
  ? T
  : never;

export const isRpcError = <TResource extends AnyResourceDefinition>(
  resource: TResource,
  error: unknown
): error is RpcError<ExtractRpcErrorPayload<ErrorOf<TResource>>> => {
  if (!(error instanceof RpcError)) {
    return false;
  }

  const meta = getResourceErrorMeta(error);

  return !!meta && meta.typeName === resource.typeName;
};
